
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"text-indent":"0","text-align":"start","line-height":"normal","text-transform":"none","block-progression":"tb","marker":"none","-inkscape-font-specification":"Sans"},attrs:{"d":"M44 5c-5.487 0-10 4.513-10 10 0 6.821 3.79 15.29 7.781 23.25-3.12 9.766-6.66 20.231-11.187 29.063-9.267 3.636-17.532 6.338-22.5 10.343a3 3 0 00-.219.25A10.125 10.125 0 005 85c0 5.487 4.513 10 10 10 2.676 0 5.259-.999 7.125-2.906a3 3 0 00.188-.156c3.657-4.368 7.97-12.29 11.812-19.532 8.856-3.483 18.137-7.028 27.094-9.156C67.757 68.52 77.216 72 85 72c5.487 0 10-4.513 10-10s-4.513-10-10-10c-6.242 0-15.314 2.228-22.25 4.563-5.622-5.278-10.787-11.87-14.5-18.876C50.903 29.517 54 21.34 54 15c0-5.487-4.513-10-10-10zm0 6c2.245 0 4 1.755 4 4 0 3.001-1.607 8.528-3.469 14.469C42.044 23.689 40 18.144 40 15c0-2.245 1.755-4 4-4zm1.719 34.219a80.247 80.247 0 0010.375 13.187c-5.93 1.622-11.722 3.7-17.438 5.875 2.76-6.23 4.97-12.696 7.063-19.062zM85 58c2.245 0 4 1.755 4 4s-1.755 4-4 4c-4.506 0-10.911-2.034-16.031-4.875C74.846 59.463 81.259 58 85 58zM25.312 75.906c-2.812 5.02-5.607 9.705-7.562 12.063C17.082 88.607 16.194 89 15 89c-2.245 0-4-1.755-4-4 0-1.056.449-2.105 1.063-2.781 2.345-1.816 7.449-3.991 13.25-6.313z","font-weight":"400","color":"#000","overflow":"visible","font-family":"Sans"}})])
          )
        }
      }
    